import * as React from "react"
import * as styles from "@/features/chat/styles.module.scss"
import { useInView } from "react-intersection-observer"
import Lottie from "@shared/uiNew/LazyLottie"
import lineAnimation from "@/shared/animations/underline.json"

interface SectionTitleProps {
  threshold: number
}

const SectionTitle: React.FC<SectionTitleProps> = ({ threshold }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold,
  })

  return (
    <h2 ref={ref} className="h1">
      <span className={styles.highlightScroll}>
        Один инструмент
        {inView && <Lottie animationData={lineAnimation} loop={false} autoplay />}
      </span>{" "}
      для роста продаж,
      <br />
      маркетинга и поддержки
    </h2>
  )
}

export default SectionTitle
